import { makeActionCreator } from '../../config/store/utils'
import {
  getParticipantsListProcess,
  getFunctionByProcess,
  getInfoPerson,
  getParticipantsListPaginate
} from '../../services/participants'
import {
  REPLACE_EQUALS_WITH_COLON,
  ADD_KEY_DOUBLE_QUOTATION_MARKS,
  ADD_VALUE_DOUBLE_QUOTATION_MARKS
} from '../../modules/utils/regexes.js'
import { onSetOpenToastSuccess } from '../UserNotificationToast/UserNotificationToast.actions.js'
import {
  ERROR_MESSAGE,
  EXCLUDED_ROLE_MESSAGE,
  PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY
} from '../../config/settings/constants.js'
import { batch } from 'react-redux'

export const SET_RESET_SELECTED_PERSON = 'SET_RESET_SELECTED_PERSON'

export const onSetResetSelectedPerson = makeActionCreator(SET_RESET_SELECTED_PERSON, 'payload')

export const SET_FUNCTION_ID_SUCCESS = 'SET_FUNCTION_ID_SUCCESS'

export const onSetFunctionIdSuccess = makeActionCreator(SET_FUNCTION_ID_SUCCESS, 'payload')

export const SET_ADD_START_DATE_SUCCESS = 'SET_ADD_START_DATE_SUCCESS'

export const onSetAddStartDateSuccess = makeActionCreator(SET_ADD_START_DATE_SUCCESS, 'payload')

export const SET_ADD_END_DATE_SUCCESS = 'SET_ADD_END_DATE_SUCCESS'

export const onSetAddEndDateSuccess = makeActionCreator(SET_ADD_END_DATE_SUCCESS, 'payload')

export const SET_RESET_SELECTS = 'SET_RESET_SELECTS'

export const onSetResetSelects = makeActionCreator(SET_RESET_SELECTS, 'payload')

export const SET_PROCESS_ID_SUCCESS = 'SET_PROCESS_ID_SUCCESS'

export const onSetProcessIdSuccess = makeActionCreator(SET_PROCESS_ID_SUCCESS, 'payload')

export const SET_SELECTED_ITEM_SUCCESS = 'SET_SELECTED_ITEM_SUCCESS'

export const onSetSelectedItemSuccess = makeActionCreator(SET_SELECTED_ITEM_SUCCESS, 'payload')

export const SET_RESET_ITEM_SELECTED_SUCCESS = 'SET_RESET_ITEM_SELECTED_SUCCESS'

export const onSetResetItemSelectedSuccess = makeActionCreator(SET_RESET_ITEM_SELECTED_SUCCESS, 'payload')

export const SET_RESET_FORM_SUCCESS = 'SET_RESET_FORM_SUCCESS'

export const onSetResetFormSuccess = makeActionCreator(SET_RESET_FORM_SUCCESS, 'payload')

export const SET_RESET_PART_FORM_SUCCESS = 'SET_RESET_PART_FORM_SUCCESS'

export const onSetResetPartFormSuccess = makeActionCreator(SET_RESET_PART_FORM_SUCCESS, 'payload')

export const SET_NEW_PERSON_SUCCESS = 'SET_NEW_PERSON_SUCCESS'

export const onSetNewPersonSuccess = makeActionCreator(SET_NEW_PERSON_SUCCESS, 'payload')

export const SET_RESET_DNI_ERROR_API_SUCCESS = 'SET_RESET_DNI_ERROR_API_SUCCESS'

export const onSetResetDNIErrorApiSuccess = makeActionCreator(SET_RESET_DNI_ERROR_API_SUCCESS, 'payload')

export const SET_VOID_PARTICIPANT_PAGINATE_LIST = 'SET_VOID_PARTICIPANT_PAGINATE_LIST'

export const onSetVoidParticipantPaginateList = makeActionCreator(SET_VOID_PARTICIPANT_PAGINATE_LIST, 'payload')

export const GET_ALL_PARTICIPANTS_PAGINATE = 'GET_ALL_PARTICIPANTS_PAGINATE'
export const GET_ALL_PARTICIPANTS_PAGINATE_ERROR = 'GET_ALL_PARTICIPANTS_PAGINATE_ERROR'
export const GET_ALL_PARTICIPANTS_PAGINATE_SUCCESS = 'GET_ALL_PARTICIPANTS_PAGINATE_SUCCESS'
export const onGetParticipantsListPaginate = makeActionCreator(GET_ALL_PARTICIPANTS_PAGINATE, 'payload')
export const onGetParticipantsListPaginateError = makeActionCreator(GET_ALL_PARTICIPANTS_PAGINATE_ERROR, 'payload')
export const onGetParticipantsListPaginateSuccess = makeActionCreator(GET_ALL_PARTICIPANTS_PAGINATE_SUCCESS, 'payload')

export const onGetParticipantsListPaginateThunk = fields => async dispatch => {
  dispatch(onGetParticipantsListPaginate({ loading: fields.loading }))
  try {
    const {
      data: {
        payload: { listadoDetalleParticipante, tamanoPaginas, totalPagina, totalRegistros, paginaActual }
      }
    } = await getParticipantsListPaginate({ fields, actionType: GET_ALL_PARTICIPANTS_PAGINATE })
    const dataProcessed = listadoDetalleParticipante.map(
      ({ cargo, detalleParticipanteId, email, nombreApellido, rut, esExtranjero, esFuncionario }) => ({
        fullName: nombreApellido,
        role: cargo,
        participantDetailId: detalleParticipanteId,
        email,
        dni: rut,
        isForeignPerson: esExtranjero,
        isOfficialOfInstitution: esFuncionario
      })
    )
    const checkList = listadoDetalleParticipante.map(item => !(item && true))
    const payload = {
      selectedList: checkList,
      allParticipants: dataProcessed,
      page: paginaActual,
      total: totalRegistros,
      totalPage: totalPagina,
      size: tamanoPaginas
    }
    return dispatch(onGetParticipantsListPaginateSuccess(payload))
  } catch (error) {
    return dispatch(onGetParticipantsListPaginateError({ error }))
  }
}

export const GET_PARTICIPANTS_LIST_PROCESS = 'GET_PARTICIPANTS_LIST_PROCESS'
export const GET_PARTICIPANTS_LIST_PROCESS_ERROR = 'GET_PARTICIPANTS_LIST_PROCESS_ERROR'
export const GET_PARTICIPANTS_LIST_PROCESS_SUCCESS = 'GET_PARTICIPANTS_LIST_PROCESS_SUCCESS'

export const onGetParticipantsListProcess = makeActionCreator(GET_PARTICIPANTS_LIST_PROCESS, 'payload')
export const onGetParticipantsListProcessError = makeActionCreator(GET_PARTICIPANTS_LIST_PROCESS_ERROR, 'payload')
export const onGetParticipantsListProcessSuccess = makeActionCreator(GET_PARTICIPANTS_LIST_PROCESS_SUCCESS, 'payload')

export const GET_PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY = 'GET_PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY'
export const onGetPurchasingMechanismAcronymisDictionary = makeActionCreator(
  GET_PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY,
  'payload'
)

export const onGetParticipantsListProcessThunk = () => async dispatch => {
  dispatch(onGetParticipantsListProcess())
  try {
    const {
      data: { payload }
    } = await getParticipantsListProcess({
      actionType: GET_PARTICIPANTS_LIST_PROCESS
    })
    const process = payload.map(({ nombre, procesoId, sigla }) => {
      // Business requirement: For both types of tenders,
      // the user must see only the word "Licitaciones".
      if (sigla === 'LC') {
        return {
          acc: sigla,
          name: 'Licitaciones',
          value: procesoId
        }
      }
      return {
        acc: sigla,
        name: nombre,
        value: procesoId
      }
    })
    const processMechanismDic = {
      ...PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY,
      ...payload.reduce((acc, item) => {
        if (!item.sigla) return acc
        acc[item.sigla] = item.procesoId
        return acc
      }, {})
    }
    dispatch(onGetPurchasingMechanismAcronymisDictionary({ processMechanismDic }))
    return dispatch(onGetParticipantsListProcessSuccess({ process }))
  } catch (error) {
    return dispatch(onGetParticipantsListProcessError({ error }))
  }
}

export const GET_FUNCTION_BY_PROCESS = 'GET_FUNCTION_BY_PROCESS'
export const GET_FUNCTION_BY_PROCESS_ERROR = 'GET_FUNCTION_BY_PROCESS_ERROR'
export const GET_FUNCTION_BY_PROCESS_SUCCESS = 'GET_FUNCTION_BY_PROCESS_SUCCESS'

export const onGetFunctionByProcess = makeActionCreator(GET_FUNCTION_BY_PROCESS, 'payload')
export const onGetFunctionByProcessError = makeActionCreator(GET_FUNCTION_BY_PROCESS_ERROR, 'payload')
export const onGetFunctionByProcessSuccess = makeActionCreator(GET_FUNCTION_BY_PROCESS_SUCCESS, 'payload')

export const onGetFunctionByProcessThunk = id => async dispatch => {
  dispatch(onGetFunctionByProcess())
  try {
    const {
      data: { payload }
    } = await getFunctionByProcess({
      id,
      actionType: GET_FUNCTION_BY_PROCESS
    })
    const functions = payload.map(({ nombre, nombreCorto, funcionId }) => ({
      name: nombreCorto || nombre,
      value: funcionId
    }))
    return dispatch(onGetFunctionByProcessSuccess({ functions }))
  } catch (error) {
    return dispatch(onGetFunctionByProcessError({ error }))
  }
}

export const GET_DNI_DATA = 'GET_DNI_DATA'
export const GET_DNI_DATA_ERROR = 'GET_DNI_DATA_ERROR'
export const GET_DNI_DATA_SUCCESS = 'GET_DNI_DATA_SUCCESS'

export const onGetDniData = makeActionCreator(GET_DNI_DATA, 'payload')
export const onGetDniDataError = makeActionCreator(GET_DNI_DATA_ERROR, 'payload')
export const onGetDniDataSuccess = makeActionCreator(GET_DNI_DATA_SUCCESS, 'payload')

export const onGetDniDataThunk = dni => async dispatch => {
  dispatch(onGetDniData())
  try {
    const data = {}
    const {
      data: { payload, errores }
    } = await getInfoPerson({
      dni: dni.replaceAll('.', ''),
      actionType: GET_DNI_DATA
    })
    if (errores && errores.length > 0) {
      data.dniErrors = errores
    }
    if (payload) {
      // Convert to object
      const jsonString = payload
        // Replace "=" with ":"
        .replace(REPLACE_EQUALS_WITH_COLON, ':')
        // Add quotes to keys and values
        .replace(ADD_KEY_DOUBLE_QUOTATION_MARKS, '"$1":')
        .replace(ADD_VALUE_DOUBLE_QUOTATION_MARKS, ':"$1"')
      const dniData = JSON.parse(jsonString)
      const { nombres: name, apellidoPaterno: lastNameP, apellidoMaterno: lastNameM, profesion: role } = dniData
      const dniLastName = lastNameP && lastNameP.length > 0 ? lastNameP : lastNameM
      data.dniData = dniData
      data.dniName = name || ''
      data.dniLastName = dniLastName || ''
      data.dniFullName = !(name && dniLastName) ? '' : `${name} ${dniLastName}`
      data.dniRole = role === EXCLUDED_ROLE_MESSAGE ? '' : role
      data.dniErrors = []
      data.dniServiceError = !(name && dniLastName)
    }
    return dispatch(onGetDniDataSuccess(data))
  } catch (error) {
    const {
      originalError: {
        response: {
          data: { errores: errors }
        }
      }
    } = error
    return batch(() => {
      dispatch(onSetOpenToastSuccess({ open: true, message: ERROR_MESSAGE, severity: 'error' }))
      dispatch(onGetDniDataError({ dniErrors: errors }))
    })
  }
}
